import { takeEvery, put, call } from "redux-saga/effects"

// Calender Redux States
import {
  UPDATE_PROFILE,
  GET_PROFILE_DATA_BY_TAB,
  CREATE_SALESMAN,
  DELETE_SALESMAN,
  SET_SALESMAN_AS_DEFAULT,
  REMOVE_TEAM_MEMBER,
  INVITE_TEAM_MEMBER,
} from "./actionTypes.js";

import {
  updateProfileSuccess,
  updateProfileFail,
  getProfileDataByTabSuccess,
  getProfileDataByTabFail,
  createSalesmanSuccess,
  createSalesmanFail,
  deleteSalesmanSuccess,
  deleteSalesmanFail,
  setSalesmanAsDefaultSuccess,
  setSalesmanAsDefaultFail,
  removeTeamMemberSuccess,
  removeTeamMemberFail,
  inviteTeamMemberSuccess,
  inviteTeamMemberFail,
} from "./actions.js"

import {
  addTeamMemberApi,
  createSalesmanApi,
  deleteSalesmanApi,
  deleteTeamMemberApi,
  profileApi,
  setDefaultSalesmanApi,
  updateProfileApi,
} from "./profileApi.js"

function* fetchProfileData({ payload }) {
  try {
    const response = yield call(profileApi, payload)
    yield put(getProfileDataByTabSuccess(response))
  } catch (error) {
    yield put(getProfileDataByTabFail(error))
  }
}

function* onUpdateProfile({ payload }) {
  try {
    const response = yield call(updateProfileApi, payload)
    yield put(updateProfileSuccess(response))
  } catch (error) {
    yield put(updateProfileFail(error))
  }
}

function* addNewSalesman({ payload }) {
  try {
    const response = yield call(createSalesmanApi, payload)
    yield put(createSalesmanSuccess(response))
  } catch (error) {
    yield put(createSalesmanFail(error))
  }
}

function* deleteSalesman({ payload }) {
  try {
    const response = yield call(deleteSalesmanApi, payload)
    yield put(deleteSalesmanSuccess(response))
  } catch (error) {
    yield put(deleteSalesmanFail(error))
  }
}

function* onUpdateDefaultSalesman({ payload }) {
  try {
    const response = yield call(setDefaultSalesmanApi, payload)
    yield put(setSalesmanAsDefaultSuccess(response))
  } catch (error) {
    yield put(setSalesmanAsDefaultFail(error))
  }
}

function* removeTeamMember({ payload }) {
  try {
    const response = yield call(deleteTeamMemberApi, payload)
    yield put(removeTeamMemberSuccess(response))
  } catch (error) {
    yield put(removeTeamMemberFail(error))
  }
}

function* addTeamMember({ payload }) {
  try {
    const response = yield call(addTeamMemberApi, payload)
    yield put(inviteTeamMemberSuccess(response))
  } catch (error) {
    yield put(inviteTeamMemberFail(error))
  }
}

function* ProfileSaga() {
  yield takeEvery(UPDATE_PROFILE, onUpdateProfile);
  yield takeEvery(GET_PROFILE_DATA_BY_TAB, fetchProfileData);
  yield takeEvery(CREATE_SALESMAN, addNewSalesman);
  yield takeEvery(DELETE_SALESMAN, deleteSalesman);
  yield takeEvery(SET_SALESMAN_AS_DEFAULT, onUpdateDefaultSalesman);
  yield takeEvery(REMOVE_TEAM_MEMBER, removeTeamMember);
  yield takeEvery(INVITE_TEAM_MEMBER, addTeamMember);
}

export default ProfileSaga
